import { useEffect as e } from "react";
//#region src/hooks/useBodyScrollLock.ts
var t = (t) => {
	e(() => {
		if (!t) return;
		let e = document.body.style.overflow;
		return document.body.style.overflow = "hidden", () => {
			document.body.style.overflow = e;
		};
	}, [t]);
};
//#endregion
export { t as useBodyScrollLock };
